import type { FeedbackStatesKeys } from "@productlane/db"
import { cn } from "@productlane/lib/src/cn"
import { Avatar, Tooltip } from "@productlane/ui"

import type { PortalMark } from "@/lib/portal-instances"

/**
 * UserCompanyAvatar draws its own done badge on this corner, so the portal mark
 * stands down rather than stacking two badges on one 20px square.
 */
export function showsPortalCornerMark({
	showResolutionState,
	state,
}: {
	showResolutionState: boolean
	state: FeedbackStatesKeys
}) {
	if (showResolutionState) return true
	return state !== "COMPLETED" && state !== "PROCESSED"
}

// Tooltip's shouldWrapChildren adds a static span, so the offset lives out here.
export function PortalCornerMark({
	mark,
	className,
}: {
	mark: PortalMark
	className?: string
}) {
	return (
		<span
			className={cn(
				"absolute -bottom-1 -right-1.5 z-10 flex rounded-[4px] ring-[1.5px] ring-white dark:ring-gray-900",
				className,
			)}
		>
			<Tooltip label={mark.name} shouldWrapChildren>
				<Avatar
					name={mark.name}
					image={mark.logoUrl}
					colorSeed={mark.colorSeed}
					roundness="sm"
					size="xxs"
					className="h-[13px] min-h-[13px] w-[13px] min-w-[13px] rounded-[4px] text-[0.4rem]"
				/>
			</Tooltip>
		</span>
	)
}
